// we don't control this button, so this value is estimated
export const helpDeskButtonDiameter = '6rem';
